import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { RARITY, nameSizeClass } from "@/lib/format";
import GP from "@/components/GP";
import { useCart } from "@/context/CartContext";
import { api, errMsg } from "@/lib/api";

export default function ProductModal({ p, onClose }) {
  const { add, has } = useCart();
  const nav = useNavigate();
  const r = RARITY[p.rarity] || RARITY.common;
  const [f, setF] = useState({ email: "", contact: "", budget: "" });
  const [busy, setBusy] = useState(false);

  const buyNow = () => { add(p); onClose(); nav("/checkout"); };
  const sendOffer = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/requests", { wanted: p.title, email: f.email, contact: f.contact, budget: parseFloat(f.budget) || 0, kind: "offer", product_id: p.id });
      toast.success("Offer sent. We will contact you shortly.");
      onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0a0a0a] border border-[#ff2a55]/40 text-white max-w-xl rounded-none p-0 overflow-hidden" data-testid="product-modal">
        <div className="relative p-8 pb-6" style={{ background: `radial-gradient(circle at 50% 0%, ${r.glow}, transparent 70%)` }}>
          <DialogHeader>
            <span className="overline-label" style={{ color: r.color }}>{r.label} / {p.category.replace("-", " ")}</span>
            <DialogTitle className={`font-display chrome-text leading-none py-2 ${p.art === "chrome" ? nameSizeClass(p.title).replace("text-6xl", "text-7xl") : "text-4xl"}`} data-testid="product-modal-title">{p.title}</DialogTitle>
            <DialogDescription className="text-[#aaa]">{p.description}</DialogDescription>
          </DialogHeader>
        </div>
        <div className="px-8 pb-8 space-y-6">
          <div className="grid grid-cols-3 gap-px bg-[#222]">
            <div className="bg-[#0a0a0a] p-3"><div className="text-[10px] tracking-[0.2em] uppercase text-[#777]">Price</div><div className="text-2xl"><GP m={p.price} obo={p.obo} coin size={20} /></div></div>
            <div className="bg-[#0a0a0a] p-3"><div className="text-[10px] tracking-[0.2em] uppercase text-[#777]">Delivery</div><div className="font-display text-2xl">{p.delivery}</div></div>
            <div className="bg-[#0a0a0a] p-3"><div className="text-[10px] tracking-[0.2em] uppercase text-[#777]">Stock</div><div className="font-display text-2xl">{p.stock === -1 ? "Open" : `${p.stock} left`}</div></div>
          </div>
          {p.specs?.length > 0 && (
            <div className="text-sm space-y-1">{p.specs.map((s) => <div key={s.k} className="flex justify-between border-b border-[#1f1f1f] py-1"><span className="text-[#888]">{s.k}</span><span>{s.v}</span></div>)}</div>
          )}
          {p.obo ? (
            <form onSubmit={sendOffer} className="space-y-3" data-testid="offer-form">
              <div className="overline-label">Make an offer</div>
              <input className="field" required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="offer-email-input" />
              <input className="field" required placeholder="Discord / contact" value={f.contact} onChange={(e) => setF({ ...f, contact: e.target.value })} data-testid="offer-contact-input" />
              <input className="field" type="number" min="0" placeholder="Your offer (M GP)" value={f.budget} onChange={(e) => setF({ ...f, budget: e.target.value })} data-testid="offer-amount-input" />
              <button className="btn-bomb w-full" disabled={busy} data-testid="offer-submit-button">{busy ? "Sending..." : "Send offer"}</button>
            </form>
          ) : (
            <div className="flex gap-3">
              <button className="btn-bomb flex-1" onClick={buyNow} data-testid="product-modal-buy-button">Buy now</button>
              <button className="btn-ghost" disabled={has(p.id)} onClick={() => { add(p); onClose(); }} data-testid="product-modal-add-button">{has(p.id) ? "In cart" : "Add to cart"}</button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
